//import { Page } from "./model/Page";
import { InputOptional, InputAction, InputType, InputImage, InputLabel, InputTable, InputPdf, UIElementHint, InputElement } from "../model/Element";
import { getElementWithPagekey, getPageByIndex, Flow } from '../FlowEngineAPI';

import { insertImageKTRLogo } from '../../pdf/PDFCreator';
import { Page } from "../model/Page";
//import { numberToString } from "pdf-lib";

import { PDFDocument, rgb, PDFPage, PDFFont, StandardFonts, PageSizes, grayscale, degrees } from 'pdf-lib'

import download from 'downloadjs'

export function setLang(code: string) {
    return;
}

export function getLang(): string {
    return "en";
}


// ==============================================================================================================================
//export interface Flow {
//    Pages: Page[]
//}

// ==============================================================================================================================
// Globally usable functions/macros in the flow structure:

// list of all house/flywheel/pumppilot combinations:
export enum HousingSizeType {
    SAE2 = "SAE 2",
    SAE3 = "SAE 3",
    SAE4 = "SAE 4",
    SAE5 = "SAE 5",

    Undefined = "UNDEFINED",
    Any = "ANY"
}

export enum FlywheelSizeType {
    SAE65 = "SAE 6.5",
    SAE75 = "SAE 7.5",
    SAE8 = "SAE 8",
    SAE10 = "SAE 10",
    SAE115 = "SAE 11.5",

    Undefined = "UNDEFINED",
    Any = "ANY"
}

export interface LayoutEntry {
    hsize: HousingSizeType,   //"SAE 2" | "SAE 3" | "SAE 4" | "SAE 5",
    fwsize: FlywheelSizeType,  //"SAE 6.5" | "SAE 7.5"  | "SAE 8"  | "SAE 10"  | "SAE 11.5",
    pumppilot: "3.25\"" | "4.00\"" | "5.00\"" | "6.00\"" | "6.50\"",
    splineofteeth: string,
    preferredSplineCallout: string,
    sizeCoupling: string,
    nomOfDiam: string,
    drawingno: string,
    partNoHub: string,
    textHub: string,
    partNoDriveFlange: string,
    textDriveFlange: string,
    partNoPumpPlate: string,
    textPumpPlate: string
}

var layoutdatalist: LayoutEntry[] = [
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE65	    , pumppilot: "3.25\"",   splineofteeth:  "9",    preferredSplineCallout: "9T \"A\" 16/32 5/8\""            , sizeCoupling: "42",     nomOfDiam: "0,625",     drawingno: "473415",     partNoHub: "BA010422041602",   textHub:"BOWEX 42/SI/9T/.625/SAE/CC/37L",     partNoDriveFlange: "010481602151",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/6.5",                     partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE65	    , pumppilot: "3.25\"",   splineofteeth: "11",    preferredSplineCallout: "11T 16/32 3/4\""                 , sizeCoupling: "42",     nomOfDiam: "0,75",      drawingno: "473415",     partNoHub: "BA010422041902",   textHub:"BOWEX 42/SI/11T/.750/SAE/CC/37L",    partNoDriveFlange: "010481602151",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/6.5",                     partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE65	    , pumppilot: "3.25\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"B\" .875\" 16/32 .875\""   , sizeCoupling: "42",     nomOfDiam: "0,875",     drawingno: "473415",     partNoHub: "BA010422042202",   textHub:"BOWEX 42/SI/13T/.875/SAE/CC/37L",    partNoDriveFlange: "010481602151",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/6.5",                     partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE65	    , pumppilot: "3.25\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"BB\"  16/32 1.00\""        , sizeCoupling: "42",     nomOfDiam: "1",         drawingno: "473415",     partNoHub: "BA010422042602",   textHub:"BOWEX 42/SI/15T/1.000/SAE/CC/37L",   partNoDriveFlange: "010481602151",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/6.5",                     partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE5,      fwsize: FlywheelSizeType.SAE65	    , pumppilot: "4.00\"",   splineofteeth:  "9",    preferredSplineCallout: "9T \"A\" 16/32 5/8\""            , sizeCoupling: "42",     nomOfDiam: "0,625",     drawingno: "473415",     partNoHub: "BA010422041602",   textHub:"BOWEX 42/SI/9T/.625/SAE/CC/37L",     partNoDriveFlange: "010481602151",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/6.5",                     partNoPumpPlate: "BA019505411011",  textPumpPlate: "PMP/SAE 5/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE5,      fwsize: FlywheelSizeType.SAE65	    , pumppilot: "4.00\"",   splineofteeth: "11",    preferredSplineCallout: "11T 16/32 3/4\""                 , sizeCoupling: "42",     nomOfDiam: "0,75",      drawingno: "473415",     partNoHub: "BA010422041902",   textHub:"BOWEX 42/SI/11T/.750/SAE/CC/37L",    partNoDriveFlange: "010481602151",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/6.5",                     partNoPumpPlate: "BA019505411011",  textPumpPlate: "PMP/SAE 5/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE5,      fwsize: FlywheelSizeType.SAE65	    , pumppilot: "4.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"B\" .875\" 16/32 .875\""   , sizeCoupling: "42",     nomOfDiam: "0,875",     drawingno: "473415",     partNoHub: "BA010422042202",   textHub:"BOWEX 42/SI/13T/.875/SAE/CC/37L",    partNoDriveFlange: "010481602151",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/6.5",                     partNoPumpPlate: "BA019505411011",  textPumpPlate: "PMP/SAE 5/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE5,      fwsize: FlywheelSizeType.SAE65	    , pumppilot: "4.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"BB\"  16/32 1.00\""        , sizeCoupling: "42",     nomOfDiam: "1",         drawingno: "473415",     partNoHub: "BA010422042602",   textHub:"BOWEX 42/SI/15T/1.000/SAE/CC/37L",   partNoDriveFlange: "010481602151",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/6.5",                     partNoPumpPlate: "BA019505411011",  textPumpPlate: "PMP/SAE 5/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "3.25\"",   splineofteeth:  "9",    preferredSplineCallout: "9T \"A\" 16/32 5/8\""            , sizeCoupling: "42",     nomOfDiam: "0,625",     drawingno: "473482",     partNoHub: "BA010422041602",   textHub:"BOWEX 42/SI/9T/.625/SAE/CC/37L",     partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "3.25\"",   splineofteeth: "11",    preferredSplineCallout: "11T 16/32 3/4\""                 , sizeCoupling: "42",     nomOfDiam: "0,75",      drawingno: "473482",     partNoHub: "BA010422041902",   textHub:"BOWEX 42/SI/11T/.750/SAE/CC/37L",    partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "3.25\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"B\" .875\" 16/32 .875\""   , sizeCoupling: "42",     nomOfDiam: "0,875",     drawingno: "473482",     partNoHub: "BA010422042202",   textHub:"BOWEX 42/SI/13T/.875/SAE/CC/37L",    partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "3.25\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"BB\"  16/32 1.00\""        , sizeCoupling: "42",     nomOfDiam: "1",         drawingno: "473482",     partNoHub: "BA010422042602",   textHub:"BOWEX 42/SI/15T/1.000/SAE/CC/37L",   partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "4.00\"",   splineofteeth:  "9",    preferredSplineCallout: "9T \"A\" 16/32 5/8\""            , sizeCoupling: "42",     nomOfDiam: "0,625",     drawingno: "473482",     partNoHub: "BA010422041602",   textHub:"BOWEX 42/SI/9T/.625/SAE/CC/37L",     partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019405411011",  textPumpPlate: "PMP/SAE 4/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "4.00\"",   splineofteeth: "11",    preferredSplineCallout: "11T 16/32 3/4\""                 , sizeCoupling: "42",     nomOfDiam: "0,75",      drawingno: "473482",     partNoHub: "BA010422041902",   textHub:"BOWEX 42/SI/11T/.750/SAE/CC/37L",    partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019405411011",  textPumpPlate: "PMP/SAE 4/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "4.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"B\" .875\" 16/32 .875\""   , sizeCoupling: "T48",    nomOfDiam: "0,875",     drawingno: "494621",     partNoHub: "BA010422042202",   textHub:"BOWEX 42/SI/13T/.875/SAE/CC/37L",    partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019405411011",  textPumpPlate: "PMP/SAE 4/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "4.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"BB\"  16/32 1.00\""        , sizeCoupling: "T48",    nomOfDiam: "1",         drawingno: "494621",     partNoHub: "BA010422042602",   textHub:"BOWEX 42/SI/15T/1.000/SAE/CC/37L",   partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019405411011",  textPumpPlate: "PMP/SAE 4/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE5,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "3.25\"",   splineofteeth:  "9",    preferredSplineCallout: "9T \"A\" 16/32 5/8\""            , sizeCoupling: "42",     nomOfDiam: "0,625",     drawingno: "473482",     partNoHub: "BA010422041602",   textHub:"BOWEX 42/SI/9T/.625/SAE/CC/37L",     partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019505050821",  textPumpPlate: "PMP/SAE 5/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE5,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "3.25\"",   splineofteeth: "11",    preferredSplineCallout: "11T 16/32 3/4\""                 , sizeCoupling: "42",     nomOfDiam: "0,75",      drawingno: "473482",     partNoHub: "BA010422041902",   textHub:"BOWEX 42/SI/11T/.750/SAE/CC/37L",    partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019505050821",  textPumpPlate: "PMP/SAE 5/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE5,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "3.25\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"B\" .875\" 16/32 .875\""   , sizeCoupling: "42",     nomOfDiam: "0,875",     drawingno: "473482",     partNoHub: "BA010422042202",   textHub:"BOWEX 42/SI/13T/.875/SAE/CC/37L",    partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019505050821",  textPumpPlate: "PMP/SAE 5/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE5,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "3.25\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"BB\"  16/32 1.00\""        , sizeCoupling: "42",     nomOfDiam: "1",         drawingno: "473482",     partNoHub: "BA010422042602",   textHub:"BOWEX 42/SI/15T/1.000/SAE/CC/37L",   partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019505050821",  textPumpPlate: "PMP/SAE 5/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE5,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "4.00\"",   splineofteeth:  "9",    preferredSplineCallout: "9T \"A\" 16/32 5/8\""            , sizeCoupling: "42",     nomOfDiam: "0,625",     drawingno: "473482",     partNoHub: "BA010422041602",   textHub:"BOWEX 42/SI/9T/.625/SAE/CC/37L",     partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019505411011",  textPumpPlate: "PMP/SAE 5/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE5,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "4.00\"",   splineofteeth: "11",    preferredSplineCallout: "11T 16/32 3/4\""                 , sizeCoupling: "42",     nomOfDiam: "0,75",      drawingno: "473482",     partNoHub: "BA010422041902",   textHub:"BOWEX 42/SI/11T/.750/SAE/CC/37L",    partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019505411011",  textPumpPlate: "PMP/SAE 5/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE5,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "4.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"B\" .875\" 16/32 .875\""   , sizeCoupling: "42",     nomOfDiam: "0,875",     drawingno: "473482",     partNoHub: "BA010422042202",   textHub:"BOWEX 42/SI/13T/.875/SAE/CC/37L",    partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019505411011",  textPumpPlate: "PMP/SAE 5/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE5,      fwsize: FlywheelSizeType.SAE75	    , pumppilot: "4.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"BB\"  16/32 1.00\""        , sizeCoupling: "42",     nomOfDiam: "1",         drawingno: "473482",     partNoHub: "BA010422042602",   textHub:"BOWEX 42/SI/15T/1.000/SAE/CC/37L",   partNoDriveFlange: "010481602410",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/7.5",                     partNoPumpPlate: "BA019505411011",  textPumpPlate: "PMP/SAE 5/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "3.25\"",   splineofteeth: "11",    preferredSplineCallout: "11T 16/32 3/4\""                 , sizeCoupling: "42",     nomOfDiam: "0,75",      drawingno: "473487",     partNoHub: "BA010422041905",   textHub:"BOWEX 42/SI/11T/.750/SAE/CC/56L",    partNoDriveFlange: "010481602630",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019305050821",  textPumpPlate: "PMP/SAE 3/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "3.25\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"B\" .875\" 16/32 .875\""   , sizeCoupling: "42",     nomOfDiam: "0,875",     drawingno: "473487",     partNoHub: "BA010422042210",   textHub:"BOWEX 42/SI/13T/.875/SAE/CC/56L",    partNoDriveFlange: "010481602630",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019305050821",  textPumpPlate: "PMP/SAE 3/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "3.25\"",   splineofteeth: "14",    preferredSplineCallout: "14T \"C\" 12/24 1-1/4\""         , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "494633",     partNoHub: "BA010652043201",   textHub:"BOWEX 65/SI/14T/1.250/SAE/CC",       partNoDriveFlange: "010651602631",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019305050821",  textPumpPlate: "PMP/SAE 3/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "3.25\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"BB\"  16/32 1.00\""        , sizeCoupling: "42",     nomOfDiam: "1",         drawingno: "473487",     partNoHub: "BA010422042605",   textHub:"BOWEX 42/SI/15T/1.000/SAE/CC/56L",   partNoDriveFlange: "010481602630",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019305050821",  textPumpPlate: "PMP/SAE 3/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "3.25\"",   splineofteeth: "19",    preferredSplineCallout: "19T 16/32 1-1/4\""               , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "494633",     partNoHub: "BA010652043203",   textHub:"BOWEX 65/SI/19T/1.250/SAE/CC",       partNoDriveFlange: "010651602631",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019305050821",  textPumpPlate: "PMP/SAE 3/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "4.00\"",   splineofteeth: "11",    preferredSplineCallout: "11T 16/32 3/4\""                 , sizeCoupling: "42",     nomOfDiam: "0,75",      drawingno: "473487",     partNoHub: "BA010422041905",   textHub:"BOWEX 42/SI/11T/.750/SAE/CC/56L",    partNoDriveFlange: "010481602630",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019305411011",  textPumpPlate: "PMP/SAE 3/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "4.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"B\" .875\" 16/32 .875\""   , sizeCoupling: "42",     nomOfDiam: "0,875",     drawingno: "473487",     partNoHub: "BA010422042210",   textHub:"BOWEX 42/SI/13T/.875/SAE/CC/56L",    partNoDriveFlange: "010481602630",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019305411011",  textPumpPlate: "PMP/SAE 3/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "4.00\"",   splineofteeth: "14",    preferredSplineCallout: "14T \"C\" 12/24 1-1/4\""         , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "494633",     partNoHub: "BA010652043201",   textHub:"BOWEX 65/SI/14T/1.250/SAE/CC",       partNoDriveFlange: "010651602631",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019305411011",  textPumpPlate: "PMP/SAE 3/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "4.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"BB\"  16/32 1.00\""        , sizeCoupling: "42",     nomOfDiam: "1",         drawingno: "473487",     partNoHub: "BA010422042605",   textHub:"BOWEX 42/SI/15T/1.000/SAE/CC/56L",   partNoDriveFlange: "010481602630",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019305411011",  textPumpPlate: "PMP/SAE 3/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "4.00\"",   splineofteeth: "19",    preferredSplineCallout: "19T 16/32 1-1/4\""               , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "494633",     partNoHub: "BA010652043203",   textHub:"BOWEX 65/SI/19T/1.250/SAE/CC",       partNoDriveFlange: "010651602631",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019305411011",  textPumpPlate: "PMP/SAE 3/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "5.00\"",   splineofteeth: "11",    preferredSplineCallout: "11T 16/32 3/4\""                 , sizeCoupling: "",       nomOfDiam: "0,75",      drawingno: "",           partNoHub: ""              ,   textHub:"-",                                  partNoDriveFlange: "",               textDriveFlange: "-",                                           partNoPumpPlate: ""              ,  textPumpPlate: "-"                                         },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "5.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"B\" .875\" 16/32 .875\""   , sizeCoupling: "",       nomOfDiam: "0,875",     drawingno: "",           partNoHub: ""              ,   textHub:"-",                                  partNoDriveFlange: "",               textDriveFlange: "-",                                           partNoPumpPlate: ""              ,  textPumpPlate: "-"                                         },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "5.00\"",   splineofteeth: "14",    preferredSplineCallout: "14T \"C\" 12/24 1-1/4\""         , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "494633",     partNoHub: "BA010652043201",   textHub:"-",                                  partNoDriveFlange: "010651602631",   textDriveFlange: "-",                                           partNoPumpPlate: "BA019305411271",  textPumpPlate: "-"                                         },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "5.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"BB\"  16/32 1.00\""        , sizeCoupling: "",       nomOfDiam: "1",         drawingno: "",           partNoHub: ""              ,   textHub:"BOWEX 65/SI/14T/1.250/SAE/CC",       partNoDriveFlange: "",               textDriveFlange: "BOWEX 65/FLE-PA/SAE/8",                       partNoPumpPlate: ""              ,  textPumpPlate: "PMP/SAE 3/ST/SAE-C/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "5.00\"",   splineofteeth: "19",    preferredSplineCallout: "19T 16/32 1-1/4\""               , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "494633",     partNoHub: "BA010652043203",   textHub:"BOWEX 65/SI/19T/1.250/SAE/CC",       partNoDriveFlange: "010651602631",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019305411271",  textPumpPlate: "PMP/SAE 3/ST/SAE-C/2-4/9.5"                },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "3.25\"",   splineofteeth: "11",    preferredSplineCallout: "11T 16/32 3/4\""                 , sizeCoupling: "42",     nomOfDiam: "0,75",      drawingno: "473487",     partNoHub: "BA010422041905",   textHub:"BOWEX 42/SI/11T/.750/SAE/CC/56L",    partNoDriveFlange: "010481602630",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "3.25\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"B\" .875\" 16/32 .875\""   , sizeCoupling: "42",     nomOfDiam: "0,875",     drawingno: "473487",     partNoHub: "BA010422042210",   textHub:"BOWEX 42/SI/13T/.875/SAE/CC/56L",    partNoDriveFlange: "010481602630",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "3.25\"",   splineofteeth: "14",    preferredSplineCallout: "14T \"C\" 12/24 1-1/4\""         , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "494633",     partNoHub: "BA010652043201",   textHub:"BOWEX 65/SI/14T/1.250/SAE/CC",       partNoDriveFlange: "010651602631",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "3.25\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"BB\"  16/32 1.00\""        , sizeCoupling: "42",     nomOfDiam: "1",         drawingno: "473487",     partNoHub: "BA010422042605",   textHub:"BOWEX 42/SI/15T/1.000/SAE/CC/56L",   partNoDriveFlange: "010481602630",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "3.25\"",   splineofteeth: "19",    preferredSplineCallout: "19T 16/32 1-1/4\""               , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "494633",     partNoHub: "BA010652043203",   textHub:"BOWEX 65/SI/19T/1.250/SAE/CC",       partNoDriveFlange: "010651602631",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019405050821",  textPumpPlate: "PMP/SAE 4/ST/SAE-A/2/9.5"                  },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "4.00\"",   splineofteeth: "11",    preferredSplineCallout: "11T 16/32 3/4\""                 , sizeCoupling: "42",     nomOfDiam: "0,75",      drawingno: "473487",     partNoHub: "BA010422041905",   textHub:"BOWEX 42/SI/11T/.750/SAE/CC/56L",    partNoDriveFlange: "010481602630",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019405411011",  textPumpPlate: "PMP/SAE 4/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "4.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"B\" .875\" 16/32 .875\""   , sizeCoupling: "42",     nomOfDiam: "0,875",     drawingno: "473487",     partNoHub: "BA010422042210",   textHub:"BOWEX 42/SI/13T/.875/SAE/CC/56L",    partNoDriveFlange: "010481602630",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019405411011",  textPumpPlate: "PMP/SAE 4/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "4.00\"",   splineofteeth: "14",    preferredSplineCallout: "14T \"C\" 12/24 1-1/4\""         , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "494633",     partNoHub: "BA010652043201",   textHub:"BOWEX 65/SI/14T/1.250/SAE/CC",       partNoDriveFlange: "010651602631",   textDriveFlange: "BOWEX 48/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019405411011",  textPumpPlate: "PMP/SAE 4/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "4.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"BB\"  16/32 1.00\""        , sizeCoupling: "42",     nomOfDiam: "1",         drawingno: "473487",     partNoHub: "BA010422042605",   textHub:"BOWEX 42/SI/15T/1.000/SAE/CC/56L",   partNoDriveFlange: "010481602630",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019405411011",  textPumpPlate: "PMP/SAE 4/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "4.00\"",   splineofteeth: "19",    preferredSplineCallout: "19T 16/32 1-1/4\""               , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "494633",     partNoHub: "BA010652043203",   textHub:"BOWEX 65/SI/19T/1.250/SAE/CC",       partNoDriveFlange: "010651602631",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019405411011",  textPumpPlate: "PMP/SAE 4/ST/SAE-B/2-4/9.5"                },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "5.00\"",   splineofteeth: "11",    preferredSplineCallout: "11T 16/32 3/4\""                 , sizeCoupling: "",       nomOfDiam: "0,75",      drawingno: "",           partNoHub: "",                 textHub:"-",                                  partNoDriveFlange: "",               textDriveFlange: "-",                                           partNoPumpPlate: ""              ,  textPumpPlate: "-"                                         },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "5.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"B\" .875\" 16/32 .875\""   , sizeCoupling: "",       nomOfDiam: "0,875",     drawingno: "",           partNoHub: "",                 textHub:"-",                                  partNoDriveFlange: "",               textDriveFlange: "-",                                           partNoPumpPlate: ""              ,  textPumpPlate: "-"                                         },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "5.00\"",   splineofteeth: "14",    preferredSplineCallout: "14T \"C\" 12/24 1-1/4\""         , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "494633",     partNoHub: "BA010652043201",   textHub:"BOWEX 65/SI/14T/1.250/SAE/CC",       partNoDriveFlange: "010651602631",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019405411271",  textPumpPlate: "PMP/SAE 4/ST/SAE-C/2-4/9.5"                },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "5.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"BB\"  16/32 1.00\""        , sizeCoupling: "",       nomOfDiam: "1",         drawingno: "",           partNoHub: "",                 textHub:"-",                                  partNoDriveFlange: "",               textDriveFlange: "-",                                           partNoPumpPlate: ""              ,  textPumpPlate: "-"                                         },
    { hsize: HousingSizeType.SAE4,      fwsize: FlywheelSizeType.SAE8	    , pumppilot: "5.00\"",   splineofteeth: "19",    preferredSplineCallout: "19T 16/32 1-1/4\""               , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "494633",     partNoHub: "BA010652043203",   textHub:"BOWEX 65/SI/19T/1.250/SAE/CC",       partNoDriveFlange: "010651602631",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/8",                       partNoPumpPlate: "BA019405411271",  textPumpPlate: "PMP/SAE 4/ST/SAE-C/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "5.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"D/E\" 8/16 1.75\""         , sizeCoupling: "65",     nomOfDiam: "1,75",      drawingno: "474367",     partNoHub: "BA010652044501",   textHub:"BOWEX 65/SI/13T/1.750/SAE/CC",       partNoDriveFlange: "010651603141",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/10",                      partNoPumpPlate: "BA019305411271",  textPumpPlate: "PMP/SAE 3/ST/SAE-C/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "5.00\"",   splineofteeth: "14",    preferredSplineCallout: "14T \"C\" 12/24 1-1/4\""         , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "474367",     partNoHub: "BA010652043201",   textHub:"BOWEX 65/SI/14T/1.250/SAE/CC",       partNoDriveFlange: "010651603141",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/10",                      partNoPumpPlate: "BA019305411271",  textPumpPlate: "PMP/SAE 3/ST/SAE-C/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "5.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"F\" 8/16 2.00\""           , sizeCoupling: "65",     nomOfDiam: "2",         drawingno: "474367",     partNoHub: "BA010652045201",   textHub:"BOWEX 65/SI/15T/2.000/SAE/CC",       partNoDriveFlange: "010651603141",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/10",                      partNoPumpPlate: "BA019305411271",  textPumpPlate: "PMP/SAE 3/ST/SAE-C/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "5.00\"",   splineofteeth: "17",    preferredSplineCallout: "17T \"CC\" 12/24 1-1/2\""        , sizeCoupling: "65",     nomOfDiam: "1,5",       drawingno: "474367",     partNoHub: "BA010652043802",   textHub:"BOWEX 65/SI/17T/1.500/SAE/CC",       partNoDriveFlange: "010651603141",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/10",                      partNoPumpPlate: "BA019305411271",  textPumpPlate: "PMP/SAE 3/ST/SAE-C/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "5.00\"",   splineofteeth: "19",    preferredSplineCallout: "19T 16/32 1-1/4\""               , sizeCoupling: "65",     nomOfDiam: "1,25",      drawingno: "474367",     partNoHub: "BA010652043203",   textHub:"BOWEX 65/SI/19T/1.250/SAE/CC",       partNoDriveFlange: "010651603141",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/10",                      partNoPumpPlate: "BA019305411271",  textPumpPlate: "PMP/SAE 3/ST/SAE-C/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "5.00\"",   splineofteeth: "21",    preferredSplineCallout: "21T 16/32 1-3/8\""               , sizeCoupling: "65",     nomOfDiam: "1,375",     drawingno: "474367",     partNoHub: "BA010652043501",   textHub:"BOWEX 65/SI/21T/1.375/SAE/CC",       partNoDriveFlange: "010651603141",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/10",                      partNoPumpPlate: "BA019305411271",  textPumpPlate: "PMP/SAE 3/ST/SAE-C/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "5.00\"",   splineofteeth: "23",    preferredSplineCallout: "23T 16/32 1-1/2\""               , sizeCoupling: "65",     nomOfDiam: "1,5",       drawingno: "474367",     partNoHub: "BA010652043801",   textHub:"BOWEX 65/SI/23T/1.500/SAE/CC",       partNoDriveFlange: "010651603141",   textDriveFlange: "BOWEX 65/FLE-PA/SAE/10",                      partNoPumpPlate: "BA019305411271",  textPumpPlate: "PMP/SAE 3/ST/SAE-C/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "6.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"D/E\" 8/16 1.75\""         , sizeCoupling: "80",     nomOfDiam: "1,75",      drawingno: "510725",     partNoHub: "BA010805044504",   textHub:"BOWEX 80/ST/13T/1.750/SAE/CC/55L",   partNoDriveFlange: "010801603141",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/10",                      partNoPumpPlate: "BA019305411521",  textPumpPlate: "PMP/SAE 3/ST/SAE-D/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "6.00\"",   splineofteeth: "14",    preferredSplineCallout: "14T \"C\" 12/24 1-1/4\""         , sizeCoupling: "",       nomOfDiam: "1,25",      drawingno: "",           partNoHub: "",                 textHub:"-",                                  partNoDriveFlange: "",               textDriveFlange: "-",                                           partNoPumpPlate: ""              ,  textPumpPlate: "-"                                         },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "6.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"F\" 8/16 2.00\""           , sizeCoupling: "80",     nomOfDiam: "2",         drawingno: "510725",     partNoHub: "BA010805045202",   textHub:"BOWEX 80/ST/15T/2.000/SAE/CC/55L",   partNoDriveFlange: "010801603141",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/10",                      partNoPumpPlate: "BA019305411521",  textPumpPlate: "PMP/SAE 3/ST/SAE-D/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "6.00\"",   splineofteeth: "17",    preferredSplineCallout: "17T \"CC\" 12/24 1-1/2\""        , sizeCoupling: "80",     nomOfDiam: "1,5",       drawingno: "510725",     partNoHub: "BA010805043802",   textHub:"BOWEX 80/ST/17T/1.500/SAE/CC/55L",   partNoDriveFlange: "010801603141",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/10",                      partNoPumpPlate: "BA019305411521",  textPumpPlate: "PMP/SAE 3/ST/SAE-D/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "6.00\"",   splineofteeth: "21",    preferredSplineCallout: "21T 16/32 1-3/8\""               , sizeCoupling: "80",     nomOfDiam: "1,25",      drawingno: "510725",     partNoHub: "BA010805043501",   textHub:"BOWEX 80/ST/21T/1.375/SAE/CC/55L",   partNoDriveFlange: "010801603141",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/10",                      partNoPumpPlate: "BA019305411521",  textPumpPlate: "PMP/SAE 3/ST/SAE-D/2-4/9.5"                },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE10	    , pumppilot: "6.00\"",   splineofteeth: "23",    preferredSplineCallout: "23T 16/32 1-1/2\""               , sizeCoupling: "80",     nomOfDiam: "1,375",     drawingno: "510725",     partNoHub: "BA010805043804",   textHub:"BOWEX 80/ST/23T/1.500/SAE/CC/55L",   partNoDriveFlange: "010801603141",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/10",                      partNoPumpPlate: "BA01930541152 ",  textPumpPlate: "PMP/SAE 3/ST/SAE-D/2-4/9.5"                },   
    { hsize: HousingSizeType.SAE2,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "5.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"D/E\" 8/16 1.75\""         , sizeCoupling: "T80",    nomOfDiam: "1,75",      drawingno: "494671",     partNoHub: "BA010805044505",   textHub:"BOWEX T80/ST/13T/1.750/SAE/CC/65L",  partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "BA019205411271",  textPumpPlate: "PMP/SAE 2/ST/SAE-C/2-4/15.9"               },
    { hsize: HousingSizeType.SAE2,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "5.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"F\" 8/16 2.00\""           , sizeCoupling: "T80",    nomOfDiam: "2",         drawingno: "494671",     partNoHub: "BA010805045204",   textHub:"BOWEX T80/ST/15T/2.000/SAE/CC/65L",  partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "BA019205411271",  textPumpPlate: "PMP/SAE 2/ST/SAE-C/2-4/15.9"               },
    { hsize: HousingSizeType.SAE2,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "5.00\"",   splineofteeth: "17",    preferredSplineCallout: "17T 8/16 2.25\""                 , sizeCoupling: "T80",    nomOfDiam: "1,5",       drawingno: "494671",     partNoHub: "BA010805045802",   textHub:"BOWEX T80/ST/17T/2.250/SAE/CC/65L",  partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "BA019205411271",  textPumpPlate: "PMP/SAE 2/ST/SAE-C/2-4/15.9"               },
    { hsize: HousingSizeType.SAE2,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "5.00\"",   splineofteeth: "21",    preferredSplineCallout: "21T 16/32 1-3/8\""               , sizeCoupling: "T80",    nomOfDiam: "1,375",     drawingno: "494671",     partNoHub: "BA010805043502",   textHub:"BOWEX T80/ST/21T/1.375/SAE/CC/65L",  partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "BA019205411271",  textPumpPlate: "PMP/SAE 2/ST/SAE-C/2-4/15.9"               },
    { hsize: HousingSizeType.SAE2,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "5.00\"",   splineofteeth: "23",    preferredSplineCallout: "23T 16/32 1-1/2\""               , sizeCoupling: "T80",    nomOfDiam: "1,5",       drawingno: "494671",     partNoHub: "BA010805043801",   textHub:"BOWEX T80/ST/23T/1.500/SAE/CC/65L",  partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "BA019205411271",  textPumpPlate: "PMP/SAE 2/ST/SAE-C/2-4/15.9"               },
    { hsize: HousingSizeType.SAE2,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "6.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"D/E\" 8/16 1.75\""         , sizeCoupling: "T80",    nomOfDiam: "1,75",      drawingno: "494671",     partNoHub: "BA010805044505",   textHub:"BOWEX T80/ST/13T/1.750/SAE/CC/65L",  partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "BA019205411521",  textPumpPlate: "PMP/SAE 2/ST/SAE-D/2-4/15.9"               },
    { hsize: HousingSizeType.SAE2,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "6.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"F\" 8/16 2.00\""           , sizeCoupling: "T80",    nomOfDiam: "2",         drawingno: "494671",     partNoHub: "BA010805045204",   textHub:"BOWEX T80/ST/15T/2.000/SAE/CC/65L",  partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "BA019205411521",  textPumpPlate: "PMP/SAE 2/ST/SAE-D/2-4/15.9"               },
    { hsize: HousingSizeType.SAE2,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "6.00\"",   splineofteeth: "17",    preferredSplineCallout: "17T 8/16 2.25\""                 , sizeCoupling: "T80",    nomOfDiam: "1,5",       drawingno: "494671",     partNoHub: "BA010805045802",   textHub:"BOWEX T80/ST/17T/2.250/SAE/CC/65L",  partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "BA019205411521",  textPumpPlate: "PMP/SAE 2/ST/SAE-D/2-4/15.9"               },
    { hsize: HousingSizeType.SAE2,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "6.00\"",   splineofteeth: "21",    preferredSplineCallout: "21T 16/32 1-3/8\""               , sizeCoupling: "T80",    nomOfDiam: "1,375",     drawingno: "494671",     partNoHub: "BA010805043502",   textHub:"BOWEX T80/ST/21T/1.375/SAE/CC/65L",  partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "BA019205411521",  textPumpPlate: "PMP/SAE 2/ST/SAE-D/2-4/15.9"               },
    { hsize: HousingSizeType.SAE2,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "6.50\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"D/E\" 8/16 1.75\""         , sizeCoupling: "T100",   nomOfDiam: "1,75",      drawingno: "",           partNoHub: "BA011005044501",   textHub:"BOWEX T100/ST/13T/1.750/SAE/N/65L",  partNoDriveFlange: "011001653521",   textDriveFlange: "BOWEX 100/FLE-PA/SAE/11.5/STEP OD/SIDE 2",    partNoPumpPlate: "BA019203121651",  textPumpPlate: "PMP/SAE 2/CI/SAE-E/4/50"                   },
    { hsize: HousingSizeType.SAE2,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "6.50\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"F\" 8/16 2.00\""           , sizeCoupling: "T100",   nomOfDiam: "2",         drawingno: "",           partNoHub: "BA011005045205",   textHub:"BOWEX 100/ST/15T/2.000/SAE/N/65L",   partNoDriveFlange: "011001653521",   textDriveFlange: "BOWEX 100/FLE-PA/SAE/11.5/STEP OD/SIDE 2",    partNoPumpPlate: "BA019203121651",  textPumpPlate: "PMP/SAE 2/CI/SAE-E/4/50"                   },
    { hsize: HousingSizeType.SAE2,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "6.50\"",   splineofteeth: "17",    preferredSplineCallout: "17T 8/16 2.25\""                 , sizeCoupling: "T100",   nomOfDiam: "1,5",       drawingno: "",           partNoHub: "BA011005045802",   textHub:"BOWEX T100/ST/17T/2.250/SAE/N/65",   partNoDriveFlange: "011001653521",   textDriveFlange: "BOWEX 100/FLE-PA/SAE/11.5/STEP OD/SIDE 2",    partNoPumpPlate: "BA019203121651",  textPumpPlate: "PMP/SAE 2/CI/SAE-E/4/50"                   },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "5.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"D/E\" 8/16 1.75\""         , sizeCoupling: "80",     nomOfDiam: "1,75",      drawingno: "",           partNoHub: "BA010805044504",   textHub:"BOWEX 80/ST/13T/1.750/SAE/CC/55L",   partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "019333121275"  ,  textPumpPlate: "SAE 3.3S/34/12-162x4xM14/127 zinc      >"  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "5.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"F\" 8/16 2.00\""           , sizeCoupling: "80",     nomOfDiam: "2",         drawingno: "",           partNoHub: "BA010805045202",   textHub:"BOWEX 80/ST/15T/2.000/SAE/CC/55L",   partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "019333121275"  ,  textPumpPlate: "SAE 3.3S/34/12-162x4xM14/127 zinc      >"  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "5.00\"",   splineofteeth: "17",    preferredSplineCallout: "17T \"CC\" 12/24 1-1/2\""        , sizeCoupling: "80",     nomOfDiam: "1,5",       drawingno: "",           partNoHub: "BA010805043806",   textHub:"BOWEX 80/ST/17T/1.500/SAE/CC/55L",   partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "019333121275"  ,  textPumpPlate: "SAE 3.3S/34/12-162x4xM14/127 zinc      >"  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "5.00\"",   splineofteeth: "21",    preferredSplineCallout: "21T 16/32 1-3/8\""               , sizeCoupling: "80",     nomOfDiam: "1,375",     drawingno: "",           partNoHub: "BA010805043501",   textHub:"BOWEX 80/ST/21T/1.375/SAE/CC/55L",   partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "019333121275"  ,  textPumpPlate: "SAE 3.3S/34/12-162x4xM14/127 zinc      >"  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "5.00\"",   splineofteeth: "23",    preferredSplineCallout: "23T 16/32 1-1/2\""               , sizeCoupling: "80",     nomOfDiam: "1,5",       drawingno: "",           partNoHub: "BA010805043804",   textHub:"BOWEX 80/ST/23T/1.500/SAE/CC/55L",   partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "019333121275"  ,  textPumpPlate: "SAE 3.3S/34/12-162x4xM14/127 zinc      >"  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "6.00\"",   splineofteeth: "13",    preferredSplineCallout: "13T \"D/E\" 8/16 1.75\""         , sizeCoupling: "80",     nomOfDiam: "1,75",      drawingno: "",           partNoHub: "BA010805044504",   textHub:"BOWEX 80/ST/13T/1.750/SAE/CC/55L",   partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "019333121523"  ,  textPumpPlate: "SAE 3.3S/34/12-162x4xM14/127 zinc      >"  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "6.00\"",   splineofteeth: "15",    preferredSplineCallout: "15T \"F\" 8/16 2.00\""           , sizeCoupling: "80",     nomOfDiam: "2",         drawingno: "",           partNoHub: "BA010805045202",   textHub:"BOWEX 80/ST/15T/2.000/SAE/CC/55L",   partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "019333121523"  ,  textPumpPlate: "SAE 3.3S/34/12-162x4xM14/127 zinc      >"  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "6.00\"",   splineofteeth: "17",    preferredSplineCallout: "17T \"CC\" 12/24 1-1/2\""        , sizeCoupling: "80",     nomOfDiam: "1,5",       drawingno: "",           partNoHub: "BA010805043802",   textHub:"BOWEX 80/ST/17T/1.500/SAE/CC/55L",   partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "019333121523"  ,  textPumpPlate: "SAE 3.3S/34/12-162x4xM14/127 zinc      >"  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "6.00\"",   splineofteeth: "21",    preferredSplineCallout: "21T 16/32 1-3/8\""               , sizeCoupling: "80",     nomOfDiam: "1,375",     drawingno: "",           partNoHub: "BA010805043501",   textHub:"BOWEX 80/ST/21T/1.375/SAE/CC/55L",   partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "019333121523"  ,  textPumpPlate: "SAE 3.3S/34/12-162x4xM14/127 zinc      >"  },
    { hsize: HousingSizeType.SAE3,      fwsize: FlywheelSizeType.SAE115		, pumppilot: "6.00\"",   splineofteeth: "23",    preferredSplineCallout: "23T 16/32 1-1/2\""               , sizeCoupling: "80",     nomOfDiam: "1,5",       drawingno: "",           partNoHub: "BA010805043804",   textHub:"BOWEX 80/ST/23T/1.500/SAE/CC/55L",   partNoDriveFlange: "010801603520",   textDriveFlange: "BOWEX 80/FLE-PA/SAE/11.5",                    partNoPumpPlate: "019333121523"  ,  textPumpPlate: "SAE 3.3S/34/12-162x4xM14/127 zinc      >"  }] 



/*  */
function getHousingOptionsForFlywheelSize(flywheelsize: string): string[] {
    flywheelsize = flywheelsize.trim();
    const housingSize: string[] = layoutdatalist.reduce((filtered: string[], entry: LayoutEntry) =>  { 
        if (flywheelsize === entry.fwsize.trim()) {
            if(!filtered.includes(entry.hsize.trim() ))
                filtered.push(entry.hsize.trim() );
        }
        return filtered;
    }, []);

    return housingSize;
}


function getSplinesNoOfTeethOptionsForFlywheelSize(flywheelsize: string): string[] {
    flywheelsize = flywheelsize.trim();
    const splinenoofteeth: string[] = layoutdatalist.reduce((filtered: string[], entry: LayoutEntry) =>  { 
        if (flywheelsize === entry.fwsize.trim()) {
            if(!filtered.includes(entry.splineofteeth.trim()))
                filtered.push(entry.splineofteeth.trim());
        }
        return filtered;
    }, []);

    return splinenoofteeth;
};


function getNomDiamOptionsForFlywheelSize(flywheelsize: string): string[] {
    flywheelsize = flywheelsize.trim();
    const nomOfDiam: string[] = layoutdatalist.reduce((filtered: string[], entry: LayoutEntry) =>  { 
        if (flywheelsize === entry.fwsize.trim()) {
            if(!filtered.includes(entry.nomOfDiam.trim()))
                filtered.push(entry.nomOfDiam.trim());
        }
        return filtered;
    }, []);

    return nomOfDiam;
};


function getPeferedSplineCalloutOptionsForFlywheelSize(flywheelsize: string): string[] {
    flywheelsize = flywheelsize.trim();
    const peferedSplineCalloutOptions: string[] = layoutdatalist.reduce((filtered: string[], entry: LayoutEntry) =>  { 
        if (flywheelsize === entry.fwsize.trim()) {
            if(!filtered.includes(entry.preferredSplineCallout.trim()))
                filtered.push(entry.preferredSplineCallout.trim());
        }
        return filtered;
    }, []);

    return peferedSplineCalloutOptions;
};


function getPumpPilotOptionsForFlywheelSize(flywheelsize: string): string[] {
    flywheelsize = flywheelsize.trim();
    const pumpPilotOptions: string[] = layoutdatalist.reduce((filtered: string[], entry: LayoutEntry) =>  { 
        if (flywheelsize === entry.fwsize.trim()) {
            if(!filtered.includes(entry.pumppilot.trim()))
                filtered.push(entry.pumppilot.trim());
        }
        return filtered;
    }, []);

    return pumpPilotOptions;
};


function getFlywheelData(fws: string, hs: string, snt: string, ppilot: string): LayoutEntry[] {
    return layoutdatalist.filter((entry: LayoutEntry) => {
            return (entry.fwsize === fws && entry.hsize === hs && entry.splineofteeth === snt && entry.pumppilot === ppilot);
        }
    )
}


function updatePage3(): boolean {
    console.log("START updatePage3");

    // Show flywheel in label:
    let fws: string | undefined = getElementWithPagekey("page1", "FlywheelSize")?.getValue() as string;
    let hs: string | undefined = getElementWithPagekey("page2", "HousingSize")?.getValue() as string;

    let snt: string | undefined = getElementWithPagekey("page3", "SplineNoOfTeeth")?.getValue() as string;
    let pp: string | undefined = getElementWithPagekey("page3", "PumpPilot")?.getValue() as string;

    let en: LayoutEntry[] = getFlywheelData(fws, hs, snt, pp);

    let e: InputElement | undefined = getElementWithPagekey("page3", "FlywheelNomDiam");
    if(e !== undefined) e.value = en.length > 0 ? en[0].nomOfDiam : "";

    e = getElementWithPagekey("page3", "FlywheelPreferedSplineCallout");
    if(e !== undefined) e.value = en.length > 0 ? en[0].preferredSplineCallout : "";

    e = getElementWithPagekey("page3", "CouplingSize");
    if(e !== undefined) e.value = en.length > 0 ? en[0].sizeCoupling : "";

    e = getElementWithPagekey("page3", "DrawingNo");
    if(e !== undefined) e.value = en.length > 0 ? en[0].drawingno : "";

    e = getElementWithPagekey("page3", "PartNoHub");
    if(e !== undefined) e.value = en.length > 0 ? en[0].partNoHub : "";

    e = getElementWithPagekey("page3", "PartNoDriveFlange");
    if(e !== undefined) e.value = en.length > 0 ? en[0].partNoDriveFlange : "";

    e = getElementWithPagekey("page3", "PartNoPumpPlate");
    if(e !== undefined) e.value = en.length > 0 ? en[0].partNoPumpPlate : "";
        
    // table
    e = getElementWithPagekey("page3", "ResultTable");
    if(e !== undefined) {
        if(en.length > 0) {
        //
            let le = en[0];
            let et: InputTable = e as InputTable;
            et.header = ["Property", "Value", "Dim"];
            et.rows = [
                ["Housing size", le.hsize, ""],
                ["Flywheel size", le.fwsize, ""],
                ["", "", ""],
                ["Flywheel nominal diameter", le.nomOfDiam, "inch"],
                ["Preferred spline callout", le.preferredSplineCallout, ""],
                ["Coupling size", le.sizeCoupling, ""],
                ["Drawing number", le.drawingno, ""],
                ["", "", ""],
                ["Partno. drive flange", le.partNoDriveFlange, ""],
                ["Desc. drive flange", le.textDriveFlange, ""],
                ["Partno. hub", le.partNoHub, ""],
                ["Desc. hub", le.textHub, ""],
                ["Partno. pump plate", le.partNoPumpPlate, ""],
                ["Desc. pump plate", le.textPumpPlate, ""],
            ];

            //egetValue() = en.length > 0 ? en[0].partNoPumpPlate : "";
        }
        else {
            let et: InputTable = e as InputTable;
            et.header = ["Name", "Value", "Dimension"];
            et.rows = [
                ["-", "-", "-"],
            ];
        }
    }

    e = getElementWithPagekey("page3", "OverviewPdf");
    let l: number = 0;
    if(e !== undefined) {
        let epdf: InputPdf = e as InputPdf;
        l = epdf.data !== undefined ? epdf.data.length : 0;

    }

    //
//    updateEmbeddedPdf();

    console.log("END updatePage3 (PDF length= " + l + " bytes)");

    return true;
}

/*
async function updateEmbeddedPdf(): Promise<boolean> {
    // first load pdf asynchronously:
    let e: InputElement | undefined = getElementWithPagekey("page3", "OverviewPdf");
    if(e !== undefined) {
        let epdf: InputPdf = e as InputPdf;
        //epdf.data = new Uint8Array(0);

        let pdfBytes: Uint8Array = await createPDF();

        console.log("Before promise pdf bytes ... (" + pdfBytes.length + " bytes )");

        epdf.value = pdfBytes.length;
        epdf.data = pdfBytes;

        console.log("... after promise pdf bytes");
    }

    console.log("PDF loaded");

    return true;
} 
*/   


// ==============================================================================================================================
//
const BORDER_LEFT: number = 50;
const FONT_SIZE: number = 10;

//var theFont: PDFFont;
/*
export function drawPageOfFlow(p: Page | undefined, page: PDFPage, line: number, fontSize: number, theFont: PDFFont, theFontBold: PDFFont): number {
    if(p === undefined)
        return line;

    line++;
    line++;

    const { width, height } = page.getSize();
    let x1: number = 50;
    let x2: number = 150;
    let y: number = height - line * fontSize;
    page.drawText(p.label, {
        //x: 50,
        //y: height - line * fontSize,
        x: x1,
        y: y,
        size: fontSize,
        font: theFontBold,
        color:  rgb(0.0, 0.0, 0.0),    // rgb(0, 0.53, 0.71),
    });

    //
    for(let i=0; i<p.elements.length; i++) {
        let e: InputElement | undefined = p.elements[i];

        if((e.type === InputType.Action) || (e.type === InputType.PageForward)  || (e.type === InputType.Image))  // we omit elements with no input value
            continue;

        //if((e instanceof InputAction) || (e instanceof InputPageForward))  // we omit elements with no input value
        //    continue;

        let outputValue: any = e.value;    // vorläufig für Demo
        if(e.type === InputType.ValueBoolean) {
            outputValue = (e.value === true ? "Ja" : "Nein");
        }

        //
        line++;

        x1 = 70;
        x2 = 250;
        y = height - line * fontSize;
        page.drawText(e.label + ": ", {
            x: x1,
            y: y,
            size: fontSize,
            font: theFont,
            color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
        });
        page.drawText(outputValue, {
            x: x2,
            y: y,
            size: fontSize,
            font: theFont,
            color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
        });
    }

    return line;
}
*/


export function drawHeader(p: Page | undefined, page: PDFPage, line: number, fontSize: number, theFontBold: PDFFont, text: string): number {
    if(p === undefined)
        return line;

    line++;

    const { width, height } = page.getSize();
    let y: number = height - line * fontSize;

    page.drawRectangle({
        x: BORDER_LEFT,
        y: y,
        width: width * 0.9,
        height: fontSize * 1.2,
        //rotate: degrees(0),
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: grayscale(0.7),    //rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });

    page.drawText(text, {
        //x: 50,
        //y: height - line * fontSize,
        x: BORDER_LEFT  + (fontSize * 0.1),
        y: y + (fontSize * 0.2),
        size: fontSize,
        font: theFontBold,
        color:  rgb(0.0, 0.0, 0.0),    // rgb(0, 0.53, 0.71),
    });

    line++;

    return line;
}

export function drawOverview(p: Page | undefined, page: PDFPage, line: number, fontSize: number, theFont: PDFFont, theFontBold: PDFFont, e: LayoutEntry): number {
    if(p === undefined)
        return line;

    const COL_LABEL_WIDTH: number = 100;

    //line++;

    const { width, height } = page.getSize();
    let x1: number = BORDER_LEFT;
    let x2: number = BORDER_LEFT + COL_LABEL_WIDTH;
    let y: number = height - line * fontSize;

    line = drawHeader(p, page, line, fontSize, theFontBold, "Selection");

    // 
    line++;
    y = height - line * fontSize;
    drawSingleLine(page, x1, x2, y, fontSize, theFont, "Housing", e.hsize);

    line++;
    y = height - line * fontSize;
    drawSingleLine(page, x1, x2, y, fontSize, theFont, "Flywheel", e.fwsize);

    line++;
    y = height - line * fontSize;
    drawSingleLine(page, x1, x2, y, fontSize, theFont, "Pump Pilot", e.pumppilot);

    line++;
    y = height - line * fontSize;
    drawSingleLine(page, x1, x2, y, fontSize, theFont, "Pump Shaft", e.preferredSplineCallout);

    // ---
    line++;
    line++;
    line = drawHeader(p, page, line, fontSize, theFontBold, "Output");

    line++;
    y = height - line * fontSize;
    //drawSingleLine(page, x1, x2, y, fontSize, theFont, "Drawing", e.drawingno);
    page.drawText("Drawing#", {
        x: x1,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.drawingno, {
        x: x2,
        y: y,
        size: fontSize * 0.8,
        font: theFontBold,
        color: rgb(0.0, 0.0, 0.0),    // rgb(0, 0.53, 0.71),
        //color: rgb(0.9453125, 0.578125, 0.0),    // rgb(0, 0.53, 0.71),  //rgb(242, 148, 0)
    });

    return line;
}


function drawSingleLine(page: PDFPage, x1: number, x2: number, y: number, fontSize: number, theFont: PDFFont, label: string, value: string): void {
    page.drawRectangle({
        x: x2  - (fontSize * 0.1),
        y: y - (fontSize * 0.1),
        width: 100,
        height: fontSize,
        //rotate: degrees(0),
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });

    page.drawText(label, {
        x: x1,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(value, {
        x: x2,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.0, 0.0, 0.0),    // rgb(0, 0.53, 0.71),
        //color: rgb(0.9453125, 0.578125, 0.0),    // rgb(0, 0.53, 0.71),  //rgb(242, 148, 0)
    });

}


function drawPartlistLandscape(p: Page | undefined, page: PDFPage, line: number, fontSize: number, theFont: PDFFont, theFontBold: PDFFont, e: LayoutEntry, borderLeft: number): number {
    if(p === undefined)
        return line;

    const { width, height } = page.getSize();

    const WIDTH_COL_1: number = 90;
    const WIDTH_COL_3: number = 90;
    const WIDTH_TABLE: number = (width * 0.61); 
    //const WIDTH_TABLE: number = (width - borderLeft); 
    const WIDTH_COL_2: number = WIDTH_TABLE - WIDTH_COL_1 - WIDTH_COL_3;

    // ---------------------
    // draw table header:
    //line = 69;
    //line = drawHeader(p, page, line, FONT_SIZE, theFontBold, "Partlist");
    //line++;

    // borders:
    let y: number = height - line * fontSize;
    page.drawRectangle({
        x: borderLeft - (fontSize * 0.1),
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_1,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(1.0, 1.0, 1.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: borderLeft + WIDTH_COL_1,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_2,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(1.0, 1.0, 1.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: borderLeft + WIDTH_COL_1 + WIDTH_COL_2,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_3,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(1.0, 1.0, 1.0),
        opacity: 1.0,
    });

    // content
    page.drawText("Component #", {
        x: borderLeft,
        y: y,
        size: fontSize * 0.8,
        font: theFontBold,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText("Description", {
        x: borderLeft + WIDTH_COL_1,
        y: y,
        size: fontSize * 0.8,
        font: theFontBold,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText("Part #", {
        x: borderLeft + WIDTH_COL_1 + WIDTH_COL_2,
        y: y,
        size: fontSize * 0.8,
        font: theFontBold,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });


    // ---------------------
    // First partno
    line++;
    y = height - line * fontSize;

    // borders:
    page.drawRectangle({
        x: borderLeft - (fontSize * 0.1),
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_1,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(1.0, 1.0, 1.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: borderLeft + WIDTH_COL_1,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_2,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: borderLeft + WIDTH_COL_1 + WIDTH_COL_2,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_3,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });

    // content
    page.drawText("1 - Drive Flange", {
        x: borderLeft,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.textDriveFlange, {
        x: borderLeft + WIDTH_COL_1,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.partNoDriveFlange, {
        x: borderLeft + WIDTH_COL_1 + WIDTH_COL_2,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });

    // ---------------------
    // Second partno
    line++;
    y = height - line * fontSize;

    // borders:
    page.drawRectangle({
        x: borderLeft - (fontSize * 0.1),
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_1,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(1.0, 1.0, 1.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: borderLeft + WIDTH_COL_1,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_2,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: borderLeft + WIDTH_COL_1 + WIDTH_COL_2,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_3,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });

    // content
    page.drawText("2 - Hub", {
        x: borderLeft,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.textHub, {
        x: borderLeft + WIDTH_COL_1,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.partNoHub, {
        x: borderLeft + WIDTH_COL_1 + WIDTH_COL_2,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });

    // ---------------------
    // Third partno
    line++;
    y = height - line * fontSize;

    // borders:
    page.drawRectangle({
        x: borderLeft - (fontSize * 0.1),
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_1,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(1.0, 1.0, 1.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: borderLeft + WIDTH_COL_1,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_2,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: borderLeft + WIDTH_COL_1 + WIDTH_COL_2,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_3,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });

    // content
    page.drawText("3 - Pump Plate", {
        x: borderLeft,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.textPumpPlate, {
        x: borderLeft + WIDTH_COL_1,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.partNoPumpPlate, {
        x: borderLeft + WIDTH_COL_1 + WIDTH_COL_2,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });

    return line;
}


function drawPartlistPortrait(p: Page | undefined, page: PDFPage, line: number, fontSize: number, theFont: PDFFont, theFontBold: PDFFont, e: LayoutEntry): number {
    if(p === undefined)
        return line;

    const { width, height } = page.getSize();

    const WIDTH_COL_1: number = 100;
    const WIDTH_COL_3: number = 100;
    const WIDTH_TABLE: number = (width * 0.9);   // - BORDER_LEFT;
    const WIDTH_COL_2: number = WIDTH_TABLE - WIDTH_COL_1 - WIDTH_COL_3;

    // ---------------------
    // draw table header:
    //line = 69;
    line = drawHeader(p, page, line, FONT_SIZE, theFontBold, "Partlist");
    line++;

    // borders:
    let y: number = height - line * fontSize;
    page.drawRectangle({
        x: BORDER_LEFT - (fontSize * 0.1),
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_1,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(1.0, 1.0, 1.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: BORDER_LEFT + WIDTH_COL_1,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_2,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(1.0, 1.0, 1.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: BORDER_LEFT + WIDTH_COL_1 + WIDTH_COL_2,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_3,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(1.0, 1.0, 1.0),
        opacity: 1.0,
    });

    // content
    page.drawText("Component #", {
        x: BORDER_LEFT,
        y: y,
        size: fontSize * 0.8,
        font: theFontBold,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText("Description", {
        x: BORDER_LEFT + WIDTH_COL_1,
        y: y,
        size: fontSize * 0.8,
        font: theFontBold,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText("Part #", {
        x: BORDER_LEFT + WIDTH_COL_1 + WIDTH_COL_2,
        y: y,
        size: fontSize * 0.8,
        font: theFontBold,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });


    // ---------------------
    // First partno
    line++;
    y = height - line * fontSize;

    // borders:
    page.drawRectangle({
        x: BORDER_LEFT - (fontSize * 0.1),
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_1,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(1.0, 1.0, 1.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: BORDER_LEFT + WIDTH_COL_1,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_2,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: BORDER_LEFT + WIDTH_COL_1 + WIDTH_COL_2,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_3,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });

    // content
    page.drawText("1 - Drive Flange", {
        x: BORDER_LEFT,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.textDriveFlange, {
        x: BORDER_LEFT + WIDTH_COL_1,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.partNoDriveFlange, {
        x: BORDER_LEFT + WIDTH_COL_1 + WIDTH_COL_2,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });

    // ---------------------
    // Second partno
    line++;
    y = height - line * fontSize;

    // borders:
    page.drawRectangle({
        x: BORDER_LEFT - (fontSize * 0.1),
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_1,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(1.0, 1.0, 1.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: BORDER_LEFT + WIDTH_COL_1,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_2,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: BORDER_LEFT + WIDTH_COL_1 + WIDTH_COL_2,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_3,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });

    // content
    page.drawText("2 - Hub", {
        x: BORDER_LEFT,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.textHub, {
        x: BORDER_LEFT + WIDTH_COL_1,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.partNoHub, {
        x: BORDER_LEFT + WIDTH_COL_1 + WIDTH_COL_2,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });

    // ---------------------
    // Third partno
    line++;
    y = height - line * fontSize;

    // borders:
    page.drawRectangle({
        x: BORDER_LEFT - (fontSize * 0.1),
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_1,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(1.0, 1.0, 1.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: BORDER_LEFT + WIDTH_COL_1,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_2,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });
    page.drawRectangle({
        x: BORDER_LEFT + WIDTH_COL_1 + WIDTH_COL_2,
        y: y - (fontSize * 0.1),
        width: WIDTH_COL_3,
        height: fontSize,
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });

    // content
    page.drawText("3 - Pump Plate", {
        x: BORDER_LEFT,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.textPumpPlate, {
        x: BORDER_LEFT + WIDTH_COL_1,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(e.partNoPumpPlate, {
        x: BORDER_LEFT + WIDTH_COL_1 + WIDTH_COL_2,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });

    return line;
}

export async function createPDF(isLandscape: boolean): Promise<Uint8Array> {
    // Create a new PDFDocument
    const pdfDoc = await PDFDocument.create();

    //const fontSize: number = 12;
    
    // Embed the Times Roman font
    let theFont: PDFFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    let theFontBold: PDFFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    
    // Add a blank page to the document
    const isA4: boolean = false;    // A4 or letter
    //const isLandscape: boolean = true;    // Landscape or Portrait

    let page: PDFPage | undefined = undefined;
    if(isA4) {
        if(isLandscape)
            page = pdfDoc.addPage([842, 595]);    // A4 Landscape
        else
            page = pdfDoc.addPage(PageSizes.A4);
    }
    else {
        if(isLandscape)
            page = pdfDoc.addPage([792, 612]);    // Letter Landscape
        else
            page = pdfDoc.addPage(PageSizes.Letter);
    }

    // Get the width and height of the page
    const { width, height } = page.getSize();
    console.log("w: " + width + ", h:" + height);
    
    // Draw a string of text toward the top of the page
    //let flow = getFlow();

    let line = 10;
    page.drawText('Flywheel selection summary', {
      x: 50,
      y: height - line * FONT_SIZE,
      size: FONT_SIZE * 2,
      font: theFont,
      color: rgb(0.9453125, 0.578125, 0.0),    // rgb(0, 0.53, 0.71),  //rgb(242, 148, 0)
    });
    line++;
    line++;
    
    // 
    let fws: string | undefined = getElementWithPagekey("page1", "FlywheelSize")?.getValue() as string;
    let hs: string | undefined = getElementWithPagekey("page2", "HousingSize")?.getValue() as string;

    let snt: string | undefined = getElementWithPagekey("page3", "SplineNoOfTeeth")?.getValue() as string;
    let pp: string | undefined = getElementWithPagekey("page3", "PumpPilot")?.getValue() as string;

    let en: LayoutEntry[] = getFlywheelData(fws, hs, snt, pp);
    if(en.length > 0) {

        console.log("Create PDF with snt= " + snt + ", pp= " + pp);

        let e: LayoutEntry = en[0];

        let pageToDisplay: Page | undefined = getPageByIndex(0);
        let overviewStartLine: number = line;
        drawOverview(pageToDisplay, page, line, FONT_SIZE, theFont, theFontBold, e);

//        line = 69;
//        line = drawHeader(pageToDisplay, page, line, FONT_SIZE, theFontBold, "Partlist");
//        line++;

        if(isLandscape) {
            line = overviewStartLine + 3;;
            var borderLeft: number = BORDER_LEFT;
            borderLeft = width * 0.35;
            line = drawPartlistLandscape(pageToDisplay, page, line, FONT_SIZE, theFont, theFontBold, e, borderLeft);
        }
        else {
            line = 69;
            line = drawPartlistPortrait(pageToDisplay, page, line, FONT_SIZE, theFont, theFontBold, e);
        }

        // ------------------------
        // insert logo:
        await insertImageKTRLogo(pdfDoc, page);
    
        // ------------------------
        // attach drawing pdf from ZVS as additional page:
        
        //const zvsUrl = process.env.PUBLIC_URL + '/drawings/ZvsDrawing.pdf';
        //const zvsUrl = "http://intranet.ktr.com/cgi-bin/ZVSViewerCGI.exe?znr=567923&u=1153&f=p&l=D&e=1";
        //const zvsUrl = "http://intranet.ktr.com/cgi-bin/ZVSViewerCGI.exe?znr=" + e.drawingno + "&u=1153&f=p&l=D&e=1";
        //const zvsUrl = "https://webinternal.ktr.com/cgi-bin/ZVSViewerCGI.exe?znr=" + e.drawingno + "&u=1153&f=p&l=D&e=1";

        const zvsUrl = process.env.PUBLIC_URL + "/drawings/" + e.drawingno + ".pdf";
        const zvsImageBytes = await fetch(zvsUrl).then((res) => res.arrayBuffer());

        //let h: number = 170;
        let h: number = 135;
        let scale: number = 1.0;
        if(isLandscape === true) {
            h = 20;
            scale = 0.7;
        }
        await embedDrawingPDF(pdfDoc, page, h, scale, zvsImageBytes);


//        zvsUrl -#- zum Anklicken ins PDF ???   

        // current date
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        var datestring = mm + '/' + dd + '/' + yyyy;        
        page.drawText(datestring, {
            x: width * 0.9,
            y: FONT_SIZE * 2,
            size: FONT_SIZE * 0.5,
            font: theFont,
            color: rgb(0.2, 0.2, 0.2),
        });
    }

    // Serialize the PDFDocument to bytes (a Uint8Array)
    const pdfBytes: Uint8Array = await pdfDoc.save();

    return pdfBytes;

    // Trigger the browser to download the PDF document
    //download(pdfBytes, "flywheel-selection.pdf", "application/pdf");
}

export async function downloadPDF(fname: string | undefined, isLandscape: boolean) {
    if(fname === undefined)
        fname = "lyout-overview";

    fname = fname + ".pdf"    

    let pdfBytes: Uint8Array = await createPDF(isLandscape);
    download(pdfBytes, fname, "application/pdf");
}

export async function embedDrawingPDF(pdfDoc: PDFDocument, page: PDFPage, h: number, scale: number, content: string | ArrayBuffer | null) {
    if(content instanceof ArrayBuffer) {
        try {
            const pdfToEmbed = await PDFDocument.load(content, {ignoreEncryption: true});

            let pagesToEmbed: PDFPage[] = pdfToEmbed.getPages();

            for(let idx: number = 0; idx < pagesToEmbed.length; idx++) {
                const docToInsert = await pdfDoc.embedPage(pagesToEmbed[idx]);
                //const page = pdfDoc.addPage();
                //const docToInsertDims = docToInsert.scale(0.5);
                const docToInsertDims = docToInsert.scale(scale);
    
                const relationWidthToHeight = docToInsertDims.width / docToInsertDims.height;
                //docToInsertDims.width = (page.getWidth() * 0.99) - BORDER_LEFT;  // set imported page to full width of hosting page
                docToInsertDims.width = (page.getWidth() * scale) - BORDER_LEFT;  // set imported page to full width of hosting page
                //docToInsertDims.height = page.getWidth() / relationWidthToHeight;   // preserve height in relation to new width
                docToInsertDims.height = docToInsertDims.width / relationWidthToHeight;   // preserve height in relation to new width
    
                page.drawPage(docToInsert, {
                        ...docToInsertDims,
                        x: BORDER_LEFT,
                        //y: 170,
                        y: h,
                      }            
                    );
            }
        }
        catch(e) {
            console.log(e);
        }
    }

}


// ==============================================================================================================================
//let globals = {
//    title: "Flywheel selection",
//    namePDF: "FlywheelSelection"
//}

// ==============================================================================================================================
let flow: Flow = {
    name: "flywheel",
    label: "flywheel-selection",
    Pages: [
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page1",
            name: "FlywheelSelection",
            label: "Flywheel selection",
            url: "www.ktrpage.com/page1",
            isSelected: false,
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "FlywheelSize",
                    label: "Size of flywheel",
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: [
                        "SAE 6.5",
                        "SAE 7.5",
                        "SAE 8",
                        "SAE 10",
                        "SAE 11.5",
                    ],
                    onAction: () => {
                        // Synchronize options depending on selection:
                        let elFlywheelSize: InputOptional | undefined = (getElementWithPagekey("page1", "FlywheelSize") as InputOptional);
                        let elHousingSize: InputOptional | undefined = (getElementWithPagekey("page2", "HousingSize") as InputOptional);
                        if((elFlywheelSize === undefined) || (elHousingSize === undefined)) return;
                        let optionsHousingSize: string[] =  getHousingOptionsForFlywheelSize(elFlywheelSize.getValue() as string);
                        elHousingSize.options = optionsHousingSize;
                        elHousingSize.value = 0;
                    }
                }),

                new InputImage({
                    type: InputType.Image,
                    name: "DimFlange",
                    label: "Dimension coupling flange (acc. SAE J620) [mm]",
                    value: "",
                    target: "DimFlange",         // takes image in public/images/wellen.jpg
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),

                new InputImage({
                    type: InputType.Image,
                    name: "FLE-PA-sketch",
                    label: "Sketch",
                    value: "",
                    target: "FLE-PA-sketch",         // takes image in public/images/wellen.jpg
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),

            ],
            // page initialization
            onPageLoad: () => { 
                let elFlywheelSize: InputOptional | undefined = (getElementWithPagekey("page1", "FlywheelSize") as InputOptional);
                let elHousingSize: InputOptional | undefined = (getElementWithPagekey("page2", "HousingSize") as InputOptional);
                if((elFlywheelSize === undefined) || (elHousingSize === undefined)) return;
                let optionsHousingSize: string[] =  getHousingOptionsForFlywheelSize(elFlywheelSize.getValue() as string);
                elHousingSize.options = optionsHousingSize;
                elHousingSize.value = 0;

                return true;
            },
            // decide if we can leave this page or not:
            isValid: () => { 
                return { res: true, msg: "" };
            },
            // select based on input the next page
            nextResolver: () => { 
                let nextPage: string = "page2";

                // DIRTY: re-think an initialize mechanism !!!
                //let elFlywheelSize: InputOptional | undefined = (getElementWithPagekey("page1", "FlywheelSize") as InputOptional);
                //elFlywheelSize.onAction();

                return nextPage;
            }
        }),


        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page2",
            name: "HousingSelection",
            label: "Housing selection",
            url: "www.ktrpage.com/page2",
            isSelected: false,
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "HousingSize",
                    label: "Size of housing",
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: [
                        "SAE 2",
                        "SAE 3",
                        "SAE 4",
                        "SAE 5",
                    ],
                    onAction: () => {
                        // Synchronize
                        let elFlywheelSize: InputOptional | undefined = (getElementWithPagekey("page1", "FlywheelSize") as InputOptional);
                        let elSplineNoOfTeeth: InputOptional | undefined = (getElementWithPagekey("page3", "SplineNoOfTeeth") as InputOptional);
                        let elPumpPilot: InputOptional | undefined = (getElementWithPagekey("page3", "PumpPilot") as InputOptional);
                        if((elSplineNoOfTeeth === undefined) || (elPumpPilot === undefined) || (elFlywheelSize === undefined)) return;

                        let optionsSplineNoOfTeeth: string[] =  getSplinesNoOfTeethOptionsForFlywheelSize(elFlywheelSize.getValue() as string);
                        elSplineNoOfTeeth.options = optionsSplineNoOfTeeth;
                        elSplineNoOfTeeth.value = 0;

                        let optionsPumpPilot: string[] =  getPumpPilotOptionsForFlywheelSize(elFlywheelSize.getValue() as string);
                        elPumpPilot.options = optionsPumpPilot;
                        elPumpPilot.value = 0;
                    }
                }),

                new InputImage({
                    type: InputType.Image,
                    name: "DimHousing",
                    label: "Housing dimensions (acc. SAE J617) [mm]",
                    value: "",
                    target: "DimHousing",         // takes image in public/images/wellen.jpg
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),

                new InputImage({
                    type: InputType.Image,
                    name: "FLE-PA-sketch",
                    label: "Sketch",
                    value: "",
                    target: "FLE-PA-sketch",         // takes image in public/images/wellen.jpg
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),

            ],
            // page initialization
            onPageLoad: () => { 
                let elFlywheelSize: InputOptional | undefined = (getElementWithPagekey("page1", "FlywheelSize") as InputOptional);
                let elSplineNoOfTeeth: InputOptional | undefined = (getElementWithPagekey("page3", "SplineNoOfTeeth") as InputOptional);
                let elPumpPilot: InputOptional | undefined = (getElementWithPagekey("page3", "PumpPilot") as InputOptional);
                if((elSplineNoOfTeeth === undefined) || (elPumpPilot === undefined) || (elFlywheelSize === undefined)) return;

                let optionsSplineNoOfTeeth: string[] =  getSplinesNoOfTeethOptionsForFlywheelSize(elFlywheelSize.getValue() as string);
                elSplineNoOfTeeth.options = optionsSplineNoOfTeeth;
                elSplineNoOfTeeth.value = 0;

                let optionsPumpPilot: string[] =  getPumpPilotOptionsForFlywheelSize(elFlywheelSize.getValue() as string);
                elPumpPilot.options = optionsPumpPilot;
                elPumpPilot.value = 0;
        
                return true;
            },
            isValid: () => { 
                return { res: true, msg: "" };
            },
            // select based on input the next page
            nextResolver: () => { 
                let nextPage: string = "page3";
                //let nextPage: string = "page99";

                // DIRTY: re-think an initialize mechanism !!!
                //let elHousingSize: InputOptional | undefined = (getElementWithPagekey("page2", "HousingSize") as InputOptional);
                //elHousingSize.onAction();
                //let elSplineNoOfTeeth: InputOptional | undefined = (getElementWithPagekey("page3", "SplineNoOfTeeth") as InputOptional);
                //elSplineNoOfTeeth.onAction();

                return nextPage;
            }
        }),

        
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page3",
            //id: "page99",
            name: "SplineNoOfTeethSelection",
            label: "Pump pilot",
            url: "www.ktrpage.com/page3",
            isSelected: false,
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "SplineNoOfTeeth",
                    label: "Spline # of teeth",
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Dropdown,
                    options: [
                        "",
                    ],
                    onAction: () => {
                        updatePage3();
                    }
                }),

                new InputOptional({
                    type: InputType.Optional,
                    name: "PumpPilot",
                    label: "Pump pilot",
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Dropdown,
                    options: [
                        "",
                    ],
                    onAction: () => {
                        updatePage3();
                    }
                }),

                /*
                new InputLabel({
                    type: InputType.Label,
                    name: "FlywheelNomDiam",
                    label: "Flywheel Nominal Diameter",
                    label_postfix: "inch",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),

                new InputLabel({
                    type: InputType.Label,
                    name: "FlywheelPreferedSplineCallout",
                    label: "Prefered Spline Callout",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),

                new InputLabel({
                    type: InputType.Label,
                    name: "CouplingSize",
                    label: "Coupling size",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),

                new InputLabel({
                    type: InputType.Label,
                    name: "DrawingNo",
                    label: "Drawing number",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),

                new InputLabel({
                    type: InputType.Label,
                    name: "PartNoHub",
                    label: "Part # hub",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),

                new InputLabel({
                    type: InputType.Label,
                    name: "PartNoDriveFlange",
                    label: "Part # drive flange",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),
                
                new InputLabel({
                    type: InputType.Label,
                    name: "PartNoPumpPlate",
                    label: "Part # pump plate",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),
                */

                new InputTable({
                    type: InputType.Table,
                    name: "ResultTable",
                    label: "Resulting flywheel data",
                    header: ["Name", "Value", ""],
                    rows: [
                             ["-", "-", ""],
                             ["-", "-", ""],
                          ],
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),

                /*
                // Preview PDF
                new InputPdf({
                    type: InputType.Pdf,
                    name: "OverviewPdf",
                    label: "Resulting pdf sheet",
                    data: new Uint8Array(0),
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any,
                }),
                */

                /*
                new InputAction({
                    type: InputType.Action,
                    name: "SendMail",
                    label: "Send Mail",
                    value: "",
                    isMandatory:  false,
                    componentname:  "",
                    uiElementHint:  UIElementHint.Button,
                    onAction: () => {
                        let url: string = createMailLink("nomail@ktr.abc", "Flywheel selection parameters");
                        window.location.href = url;
                        //window.open(url);
                    }
                }),
                */

                new InputAction({
                    type: InputType.Action,
                    name: "DownloadPDFPortrait",
                    label: "PDF (Portrait)",
                    value: "",
                    isMandatory:  false,
                    componentname:  "",
                    uiElementHint:  UIElementHint.Button,
                    onAction: () => {
                        downloadPDF(flow.label, false);
                    }
                }),

                new InputAction({
                    type: InputType.Action,
                    name: "DownloadPDFLandscape",
                    label: "PDF (Landscape)",
                    value: "",
                    isMandatory:  false,
                    componentname:  "",
                    uiElementHint:  UIElementHint.Button,
                    onAction: () => {
                        downloadPDF(flow.label, true);
                    }
                }),


            ],
            // page initialization
            onPageLoad: () => { 
                updatePage3();
                return true;
            },
            // decide if we can leave this page or not:
            isValid: () => { 
                return { res: true, msg: "" };
            },
            // select based on input the next page
            nextResolver: () => { 
                //let nextPage: string = "page99";
                let nextPage: string = "page3";
                return nextPage;
            }
        }),



        // ---------------------------------------------------------------------------------------------------------------

    ]
    };

export { flow };
